import { render, staticRenderFns } from "./form-appearance-drawer.vue?vue&type=template&id=974661b4&scoped=true"
import script from "./form-appearance-drawer.vue?vue&type=script&lang=js"
export * from "./form-appearance-drawer.vue?vue&type=script&lang=js"
import style0 from "./form-appearance-drawer.vue?vue&type=style&index=0&id=974661b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974661b4",
  null
  
)

export default component.exports